<div class="row no-sides-mobile extend-row justify-content-center">
    <div class="col-12 col-sm-12 col-md-9 col-lg-8 col-xl-7 no-sides-mobile"
        [style.padding-top.px]="padding_top" [style.padding-bottom.px]="padding_bottom">
        <div class="card card-counter shadow ">
            <div class="card-body sml-pad">
                <div class="container-fluid p-0 no-sides-mobile">
                    <div class="row no-sides-mobile">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 no-sides-mobile mb-md-5">
                            <div class="w-100 rounded d-flex align-items-center exam-counter-container no-gutters">
                                <div class="col-6 col-md-5 text-center">
                                    <div class="counter-digit">{{ examsPassed[0] }}</div>
                                    <div class="counter-digit">{{ examsPassed[1] }}</div>
                                    <div class="counter-digit">{{ examsPassed[2] }}</div>
                                    <div class="counter-digit">{{ examsPassed[3] }}</div>
                                </div>
                                <div class="col-6 col-md-7 text-center font-size-25 font-weight-bold">
                                    Exam Passes in {{ year }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 no-sides-mobile">
                            <div class="d-flex align-items-center justify-content-end course-selector">
                                <mat-select class="py-5 px-4 rounded d-inline-block"
                                    placeholder="{{ coursePlaceholderText }}" [(ngModel)]="selectedCourse">
                                    <mat-option *ngFor="let course of courses" [value]="course">
                                        {{ course.short_title }}
                                    </mat-option>
                                </mat-select>

                                <button type="button"
                                    class="d-inline-block btn btn-primary btn-lg font-weight-bold hidden-mobile"
                                    (click)="getStarted()">
                                    Get Started
                                </button>
                            </div>
                            <button type="button"
                                class="d-inline-block btn btn-primary btn-lg rounded-pill font-weight-bold show-mobile"
                                (click)="getStarted()">
                                Get Started
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>